import { Button } from '@/components/ui/button';
import type { DomainSearchResult, SelectedDomain } from './types';

interface DomainPoolProps {
  searchResults: DomainSearchResult[];
  selectedDomains: SelectedDomain[];
  onToggleDomain: (domain: DomainSearchResult) => void;
  currencySymbol?: string;
}

export function DomainPool({ searchResults, selectedDomains, onToggleDomain, currencySymbol = '$' }: DomainPoolProps) {
  if (searchResults.length === 0) {
    return null;
  }

  const isSelected = (domain: string) =>
    selectedDomains.some(d => d.domain === domain);

  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground px-4">Suggested domains:</p>
      <div className="flex flex-wrap gap-3">
        {searchResults.map((result) => (
          <Button
            key={result.domain}
            type="button"
            variant="secondary"
            size="xs"
            disabled={!result.available}
            onClick={() => result.available && onToggleDomain(result)}
            className={
              isSelected(result.domain)
                ? 'bg-info-surface-hover !bg-none text-info-foreground border-transparent hover:bg-info-surface-hover focus:ring-0 focus:ring-offset-0'
                : 'focus:ring-0 focus:ring-offset-0'
            }
          >
            {result.domain}
            {result.available && result.price && (
              <span className={`text-xs ${isSelected(result.domain) ? 'text-info-foreground' : 'opacity-75'}`}>
                {currencySymbol}{(result.price / 100).toFixed(0)}
              </span>
            )}
            {!result.available && (
              <span className="text-xs">unavailable</span>
            )}
          </Button>
        ))}
      </div>
    </div>
  );
}
